import { __decorate } from "tslib";
import { __metadata } from "tslib";
import { Component, Input } from "@angular/core";
import { AppState } from "../../app.service";
import { TrackingCheckout } from "@api/services/tracking";
import { scrollTo } from "@api/utils";
import ScrollHelper from "../../../utils/scroll-helper";
var CheckoutFormComponent = /*@__PURE__*/ (function () {
    /**
     * TypeScript public modifiers
     */
    function CheckoutFormComponent(appState) {
        this.appState = appState;
        /**
         * Set our default values
         */
        this.localState = { value: "" };
        this.step = 1;
        this.contactPreviewHTML = null;
        this.ready = false;
        this.terms = {};
    }
    CheckoutFormComponent.prototype.ngOnInit = function () {
        this.scroller = ScrollHelper.getInstance();
        this.onContactDetailsSubmit =
            this.handleContactDetailsSubmission.bind(this);
        this.onNumberPortingSubmit = this.handleNumberPortingSubmit.bind(this);
        this.onBankAccountSubmit = this.handleBankAccountSubmit.bind(this);
        this.onTermsChange = this.handleTermsChange.bind(this);
        this.activateContactDetails = this.activateContactDetails.bind(this);
        this.activateNumberPorting = this.activateNumberPorting.bind(this);
        this.activateBankAccount = this.activateBankAccount.bind(this);
        var tracking = new TrackingCheckout();
        tracking
            .setStep("1")
            .setName("checkout")
            .setStatus(["start"])
            .setPageType("checkout")
            .track();
    };
    CheckoutFormComponent.prototype.ngAfterViewChecked = function () {
        this.scroller.doScroll();
    };
    CheckoutFormComponent.prototype.scrollToErrorMsg = function (event) {
        var _this = this;
        setTimeout(function () { return _this.scroller.scrollToFirst("alert error"); }, 200);
    };
    CheckoutFormComponent.prototype.handleContactDetailsSubmission = function (contactDetails) {
        this.contactPreviewHTML = "\n            <div>" + contactDetails.company + "</div>\n            <div>" + contactDetails.street + " " + contactDetails.streetNumber + "</div>\n            <div>" + contactDetails.zipCode + " " + contactDetails.city + "</div>\n            <div></div>\n            <div>" + contactDetails.phonePrefix + " " + contactDetails.phoneNumber + "</div>\n            <div>" + contactDetails.email + "</div>\n        ";
        this.contactDetails = contactDetails;
        this.dataChanged();
        var tracking = new TrackingCheckout();
        tracking
            .setStep("2")
            .setName("number porting")
            .setStatus([])
            .setPageType("number porting")
            .track();
        this.step = 2;
        setTimeout(function () {
            scrollTo("#checkout-number-porting", 150);
        }, 30);
    };
    CheckoutFormComponent.prototype.handleNumberPortingSubmit = function (numberPorting) {
        this.numberPorting = numberPorting;
        this.dataChanged();
        var tracking = new TrackingCheckout();
        tracking
            .setStep("3")
            .setName("payment")
            .setStatus([])
            .setPageType("payment")
            .track();
        this.step = 3;
        setTimeout(function () {
            scrollTo("#checkout-bank-account", 150);
        }, 30);
    };
    CheckoutFormComponent.prototype.handleBankAccountSubmit = function (bankAccount) {
        this.bankAccount = bankAccount;
        this.dataChanged();
        var tracking = new TrackingCheckout();
        tracking
            .setStep("4")
            .setName("summary")
            .setStatus([])
            .setPageType("summary")
            .track();
        this.step = 4;
        setTimeout(function () {
            scrollTo("#checkout-terms", 150);
        }, 30);
    };
    CheckoutFormComponent.prototype.handleTermsChange = function (terms) {
        this.terms = terms;
        this.dataChanged();
        var tracking = new TrackingCheckout();
    };
    CheckoutFormComponent.prototype.submitState = function (value) { };
    CheckoutFormComponent.prototype.activateContactDetails = function () {
        this.step = 1;
    };
    CheckoutFormComponent.prototype.activateNumberPorting = function () {
        this.step = 2;
    };
    CheckoutFormComponent.prototype.activateBankAccount = function () {
        this.step = 3;
    };
    CheckoutFormComponent.prototype.dataChanged = function () {
        this.onDataChange({
            contactDetails: this.contactDetails,
            numberPorting: this.numberPorting,
            bankAccount: this.bankAccount,
            terms: this.terms,
        });
    };
    return CheckoutFormComponent;
}());
export { CheckoutFormComponent };



//////////////////
// WEBPACK FOOTER
// ./app/bundles/enterprise-shop/src/app/modules/checkout-form/checkout-form.component.ts
// module id = null
// module chunks = 